import colors from "core/resources/theme/colors";
import { useMemo } from "react";
import { Control } from "react-hook-form";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";
import { FormAcordo, FormAcordoParcela } from "features/acordo/typings";
import { Text, Box } from "@chakra-ui/react";

interface useListagemParcelasAcordoColumnsProps {
  control: Control<FormAcordo, any>;
  enabledEdit: boolean;
}
function useListagemParcelasAcordoColumns({
  control,
  enabledEdit,
}: useListagemParcelasAcordoColumnsProps) {
  return useMemo(() => {
    return [
      {
        title: "Parcela",
        width: 300,
        render: (original: FormAcordoParcela) => (
          <Text> {original.numeroParcela}ª </Text>
        ),
      },
      {
        title: "Vencimento",
        width: 300,
        shouldCellUpdate: () => true,
        render: (original: FormAcordoParcela) => (
          <Box maxW={180}>
            <Field
              name={`parcelas.${original.numeroParcela - 1}.dataVencimento`}
              control={control}
              inputProps={{
                type: "date",
              }}
            />
          </Box>
        ),
      },
      {
        title: "Valor",
        width: 150,
        shouldCellUpdate: () => true,
        render: (original: FormAcordoParcela) => (
          <Box w={100}>
            <Field
              name={`parcelas.${original.numeroParcela - 1}.valor`}
              control={control}
              render={({ field, isInvalid }) => (
                <InputMoney
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                  disabled={!enabledEdit}
                  placeholder="0"
                  decimalScale={2}
                  decimalsLimit={2}
                  backgroundColor={colors.blue100}
                />
              )}
            />
          </Box>
        ),
      },
    ];
  }, [control, enabledEdit]);
}

export default useListagemParcelasAcordoColumns;
